import { Component, EventEmitter, Input, Output } from '@angular/core';
import { WalletPointsTransactionService } from './services/wallet-points-transaction.service';
import { EmployeePointsByMonth, EmployeePointsHistory } from './model/wallet-points-transactions';

@Component({
  selector: 'app-wallet-points-transactions',
  templateUrl: './wallet-points-transactions.component.html'
})
export class WalletPointsTransactionsComponent {
  
  @Input() id!: string;
  @Input() currentPoints!: number;
  dataLoading = false;
  @Output() close = new EventEmitter<boolean>();


  employeePoints!: EmployeePointsHistory | null;
  employeePointsLoading = false;

  employeePointsByMonthLoading = false;

  today = new Date();

  constructor(private service: WalletPointsTransactionService) {
  }


  ngOnInit(): void {
    this.EmployeePointsHistory();
  }

  EmployeePointsHistory() {
    this.employeePointsLoading = true;
    this.service.EmployeePointsHistory(this.id).subscribe((res: EmployeePointsHistory) => {
      this.employeePoints = res;
      this.employeePointsLoading = false;
    })
  }

  getEmployeeHistoryByMonth(year_and_month: any, i: number) {
    let data = {
      employee_id: this.id,
      year_and_month: year_and_month
    }
    this.employeePoints!.data.list[i].loading = true;
    this.service.GetEmployeePointsHistoryByMonth(data).subscribe((res: EmployeePointsByMonth) => {
      this.employeePoints!.data.list[i].history = res;
      this.employeePoints!.data.list[i].loading = false;

      this.employeePoints!.data.list[i].history.data.list.map((item) => {
        item.isShow = false;
      });
    })
  }

  ShowHideDetails(i: any,x: any, isShow: boolean) {
    let target = this.employeePoints!.data.list[i].history.data.list[x];
    target.isShow = isShow;
    this.updateExpireAter(target)
    window.setInterval(() => {
      this.updateExpireAter(target)
    }, 1000)
  }

  updateExpireAter(target: any) {
    if (target.message.expire_after > 0) {
      target.message.expire_after = target.message.expire_after - 1;
      target.timer = this.getElapsedTime(target.message.expire_after);
    }
  }


  getElapsedTime(allSeconds: number) {
    let minutes = 0;
    let seconds = 0;
    let totalSeconds = allSeconds;

    if (allSeconds < 0) {
      totalSeconds = Math.abs(allSeconds);
    }

    let m = '00', s = '00';

    if (totalSeconds >= 60) {
      minutes = Math.floor(totalSeconds / 60);
      m = minutes > 9 ? "" + minutes : "0" + minutes;
      totalSeconds -= 60 * minutes;
    }

    seconds = totalSeconds;
    s = seconds > 9 ? "" + seconds : "0" + seconds;

    return { m, s };
  }
}
